import { useSelector } from "react-redux";
import LoadingBar from "./LoadingBar";
import { anyPointedDevice } from "../../reducers/devices";
import ConfirmPopup from "../popups/ConfirmPopup";
import { getSavedAlbumsLoadingProgress } from "../../reducers/disablingProcesses";
import { PARTIALLY_BLOCKING_POPUP_ZINDEX as zIndex } from "../../utils/constants/otherConstants";
import BlockingScreenLayer from "../common/containers/BlockingScreenLayer";

const AlbumListLoadingScreen = () => {
    const loadingProgress = useSelector(getSavedAlbumsLoadingProgress);
    const pointedDevice = useSelector(anyPointedDevice);

    const ShowingPopup = () => {
        if(loadingProgress !== 100)
        {
            return (
                <LoadingBar loadingProgress={loadingProgress} />
            )
        }

        if(!pointedDevice)
        {
            return (
                <ConfirmPopup 
                    title="There is no selected device!"
                    message="Please, select one of the available devices" />
            )
        }
    }

    return (
        <>
        {
            (loadingProgress !== 100 || !pointedDevice) &&
            <BlockingScreenLayer zIndex={zIndex}>
                <div className="full-width full-height d-flex flex-row jc-center ai-center">
                    <ShowingPopup />
                </div>
            </BlockingScreenLayer>
        }
        </>
    )
}

export default AlbumListLoadingScreen;